import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from '@mui/material'
import type { SearchResultItem } from '@/features/search/types'
import {
  informationForProvidersTableMap,
  informationTableMap,
} from '../helpers/maps'
import { getTableValue } from '../helpers/utils'

interface Props {
  openDrawer: boolean
  searchResultItem: SearchResultItem
  title: 'Information' | 'Information for Providers'
}

export const InformationTable = (props: Props) => {
  const { openDrawer, searchResultItem, title } = props
  const infoMap =
    title === 'Information'
      ? informationTableMap
      : informationForProvidersTableMap

  return (
    <TableContainer component={Paper} elevation={2}>
      <Box sx={{ p: '16px', borderBottom: '1px solid #e0e0e0' }}>
        <Typography variant="h4">{title}</Typography>
      </Box>

      <Table size={openDrawer ? 'small' : 'medium'}>
        <TableBody>
          {infoMap.map((mapItem) => {
            const value = getTableValue(searchResultItem, mapItem)

            return (
              <TableRow
                key={mapItem.header}
                sx={{ '&:nth-of-type(odd)': { backgroundColor: '#f7f7f7' } }}
              >
                <TableCell component="th" scope="row" sx={{ fontWeight: 600 }}>
                  {mapItem.header}
                </TableCell>
                <TableCell>{value}</TableCell>
              </TableRow>
            )
          })}
        </TableBody>
      </Table>
    </TableContainer>
  )
}
